import { Row } from '@/components/container/Container';
import SelectLanguageDropdown from '@/components/form-inputs/SelectLanguageDropdown';
import { TextLink } from '@/components/text/Texts';
import '../../authentication-screens.styles.css';

const Footer = () => {
	const buttons = [
		{ label: 'Terms and Conditions', link: 'https://www.xpress.ph/terms' },
		{ label: 'Privacy Policy', link: 'https://www.xpress.ph/privacy-policy' },
	];

	return (
		<Row className="py-3 gap-2.5 tablet:flex-wrap">
			<SelectLanguageDropdown />
			{buttons.map((item) => (
				<TextLink
					className="font-poppins text-label-large2 text-primary h-10 px-3 py-2"
					key={item.label}
					text={item.label}
					link={item.link}
					target="_blank"
				/>
			))}
		</Row>
	);
};

export default Footer;
